import { createContext, useContext } from "react";

/**
 * When a nested curriculum tab strip (inside "Select Subject") is scrolled horizontally,
 * callers should invoke this so the active subject tab in MembersArea stays visible.
 */
export const CurriculumSubjectNavSyncContext = createContext<(() => void) | null>(null);

export function useCurriculumSubjectNavSyncOnChildStripScroll(): (() => void) | null {
  return useContext(CurriculumSubjectNavSyncContext);
}
